import FeedbackDisplay from './Table/FeedbackDisplay/FeedbackDisplay';
import Table from './Table/Table';

export default {
    FeedbackDisplay,
    Table
};
